module.exports = __webpack_public_path__ + "static/img/crown.a427f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crown.png
// module id = f2Ig
// module chunks = 1